import { apiDelete, apiPost, apiRoutes, buildApiRoute, createStandardCrudApi } from "./entityApiShared.js";
import type { CrudApi, EntityCreateRequest, EntityRecord, EntityUpdateRequest } from "../types/api.types.js";

export type UserDto = EntityRecord;
export type UserCreateRequest = EntityCreateRequest;
export type UserUpdateRequest = EntityUpdateRequest;
export type UserRoleAssignmentRequest = Readonly<{ roleId: string }>;
export type UserOrganizationScopeAssignmentRequest = Readonly<{ scopeId: string }>;

const userCrud = createStandardCrudApi<UserDto, UserCreateRequest, UserUpdateRequest>({
  list: apiRoutes.users.list,
  get: apiRoutes.users.get,
  create: apiRoutes.users.create,
  update: apiRoutes.users.update,
  delete: apiRoutes.users.delete,
});

export const userApi: CrudApi<UserDto, UserCreateRequest, UserUpdateRequest> & {
  readonly assignRole: (id: string, payload: UserRoleAssignmentRequest, idempotencyKey?: string) => Promise<UserDto>;
  readonly removeRole: (id: string, roleId: string) => Promise<void>;
  readonly assignOrganizationScope: (id: string, payload: UserOrganizationScopeAssignmentRequest, idempotencyKey?: string) => Promise<UserDto>;
  readonly removeOrganizationScope: (id: string, scopeId: string) => Promise<void>;
} = {
  ...userCrud,
  assignRole: (id, payload, idempotencyKey) => apiPost<UserDto>(buildApiRoute(apiRoutes.users.assignRole, { id }), payload, { idempotencyKey }),
  removeRole: async (id, roleId) => { await apiDelete<void>(buildApiRoute(apiRoutes.users.removeRole, { id, roleId })); },
  assignOrganizationScope: (id, payload, idempotencyKey) => apiPost<UserDto>(buildApiRoute(apiRoutes.users.assignOrganizationScope, { id }), payload, { idempotencyKey }),
  removeOrganizationScope: async (id, scopeId) => { await apiDelete<void>(buildApiRoute(apiRoutes.users.removeOrganizationScope, { id, scopeId })); },
};
